import { Component, Provide, Ref } from "vue-property-decorator";
import R from "ramda";
import Header from "@/components/BaseCurd/header";
import WorkstationSetting from "./components/workstationSetting";
import renderUtils from "@/components/RenderUtils";
import ProductInfo from "./components/productInfo";
import AssociatedIots from "./components/associatedIots";
import ParameterSetting from "./components/parameterSetting";
import MergeHooks from "@/decorators/mergeHooks";
import { Types, ACLS } from "@/components/RenderUtils/utils/constants";
import {
  getCombineMapper,
  getDeleteFunction,
} from "@/components/RenderUtils/utils/index";
import getStyles from "@/components/RenderUtils/utils/style";
import getLang from "@/components/RenderUtils/utils/lang";
import {
  WorkStationBriefVO,
  WorkStationServiceProxy,
  WorkStationWorkingConditionParamSettingServiceProxy,
  WorkStationIotServiceProxy,
} from "@/service-proxies/app-v2/workStation.service-proxies";

const service = new WorkStationServiceProxy();
const IotService = new WorkStationIotServiceProxy();
const paramSettingService = new WorkStationWorkingConditionParamSettingServiceProxy();

@Component({
  WorkstationSetting,
  Header,
  ProductInfo,
  ParameterSetting,
  AssociatedIots,
})
@MergeHooks
export default class WorkstationMaintain extends renderUtils {
  @Ref() readonly infoRef!: ProductInfo;
  @Ref() readonly iotRef!: AssociatedIots;
  @Provide() refresh = {
    associatedIots: () => this.refreshAssociatedIots(),
    parameterSetting: () => this.refreshParameterSetting(),
    lists: () => this.getlIST(),
    productInfo: () => this.refreshProductInfo(),
  };
  selectId = "";
  select = {};
  loading = false;
  lists: WorkStationBriefVO[] = [];
  productInfo = {};
  parameterSetting = [];
  associatedIot = [];
  showModal = false;
  step = 0;
  selectedRowKeys = [];
  printVisible = false
  dataList = []

  get headerConfig() {
    return {
      left: {
        buttons: [
          {
            value: this.lang.create_worksatation,
            props: {
              type: "primary",
            },
            on: {
              click: () => (this.showModal = true),
            },
            directives: [
              {
                name: "acl",
                value: ACLS.ADD_RELATE,
              },
            ],
          },
          {
            value: this.$t("page_print_code"),
            props: {
              type: "default",
              disabled:this.selectedRowKeys.length === 0,
            },
            on: {
              click: () =>this.printing(),
            },
            directives: [
              {
                name: "acl",
                value: ACLS.ADD_RELATE,
              },
            ],
          },
        ],
      },
      right: {
        search: {
          props: {
            placeholder: this.lang.placeholder,
            enterButton: this.lang.search,
            allowClear: true,
          },
          on: {
            search: this.getlIST,
          },
        },
      },
    };
  }

  get lang() {
    return getLang(this);
  }

  created() {
    this.getlIST();
  }

  setState(key) {
    return (value) => this.$set(this, key, value);
  }

  spliceState(key) {
    return (value) => this[key].splice(R.indexOf(value, this[key]), 1);
  }

  async getlIST(filter = "", chooseFirst = true) {
    const setLists = this.setState("lists");
    const selectFirstWorkstation = (data) => {
      if (chooseFirst && data && data.length > 0) {
        this.chooseList(data[0].id);
      } else {
        this.resetFields();
      }
    };

    const effectCb = R.pipe(
      R.prop("records"),
      getCombineMapper,
      R.map(R.__, [setLists, selectFirstWorkstation])
    );

    return R.pipe(
      service.getPageWorkStations.bind(service),
      R.andThen(effectCb)
    )(1, { filter: filter }, -1);
  }

  deleteList(row) {
    const effectCb = () => {
      this.$message.success(this.lang.delete_success);
      this.spliceState("lists")(row);
      if (this.lists.length) {
        this.chooseList(this.lists[0].id);
      } else {
        this.resetFields();
      }
    };

    const fetchFn = service.deleteWorkStation.bind(service);

    getDeleteFunction(fetchFn, effectCb)(row);
  }

  resetFields() {
    this.selectId = "";
    this.select = {};
    this.productInfo = {};
    this.parameterSetting = [];
    this.associatedIot = [];
  }

  getData() {
    this.dataList = []
    // console.log(1111,this.lists)
    this.selectedRowKeys.map(id =>{
      this.lists.map(item => {
        if(id === item.id) {
          this.dataList.push({
            code: item.code,
            name: item.name
          })
        }
      })
    })
  }

  printing() {
    this.getData()
    this.printVisible = true

  }
  cancel() {
    this.selectedRowKeys = []
    this.printVisible = false
  }
  handlerPrint() {
    this.selectedRowKeys = []
    this.printVisible = false
  }

  chooseList(id) {
    // console.log(id);
    this.selectId = id
    this.selectedRowKeys = [id]
    const refreshFns = [
      R.pipe(R.propEq("id"), R.find(R.__, this.lists), this.setState("select")),
      this.setState("selectId"),
      this.getProductInfoFunction(),
      this.getParameterSettingFunction(),
      this.getAssociatedIotFunction(),
    ];
    R.map(getCombineMapper(id), refreshFns);
  }

  refreshAssociatedIots() {
    this.getAssociatedIotFunction()(this.selectId);
  }

  refreshParameterSetting() {
    this.getParameterSettingFunction()(this.selectId);
  }

  getDetailFunction(fetchFn, prop) {
    const effectCb = this.setState(prop);
    return R.pipe(fetchFn, R.andThen(effectCb));
  }

  render() {
    return (
      <div class="full-height" style={getStyles("transparent")}>
        <Header config={this.headerConfig} style={getStyles("header")} />
        <code-model
        visible={this.printVisible}
        onCancel={this.cancel}
        dataList={this.dataList}
        onprint={this.handlerPrint}
        >
      </code-model>
        <div style={getStyles("body")}>
          <a-row
            class="full-height"
            align="stretch"
            style="display:flex !important"
          >
            <a-col class="full-height">{this.renderLeft()}</a-col>
            <div v-resize={"x"}></div>
            <a-col class="full-height flex-1" style={getStyles("overflowY")}>
              {this.renderRight()}
            </a-col>
          </a-row>
        </div>
        {this.renderModal()}
      </div>
    );
  }

  renderModal() {
    const changeModalType = this.setState("showModal");

    const steps = [
      {
        title: this.lang.first_step,
        render: () => (
          <ProductInfo
            type={Types.create}
            mainStyle={{ boxShadow: "none" }}
            sourceData={this.productInfo}
            ref="infoRef"
            showHeader={false}
          />
        ),
        next: async () => {
          const id = await this.infoRef.submit();
          await this.getlIST("", false);
          this.chooseList(id);
          return true;
        },
      },
      {
        title: this.lang.second_step,
        render: () => (
          <WorkstationSetting
            type="create"
            productInfo={this.productInfo}
            parameterSetting={this.parameterSetting}
            associatedIot={this.associatedIot}
            workstationId={this.selectId}
            workstation={this.select}
          />
        ),
      },
      // {
      //   title: this.lang.associated_iot,
      //   render: () => (

      //   ),
      // },
      // {
      //   title: this.lang.transport_directory,
      //   render: () => ,
      // },
    ];

    const props = {
      bodyStyle: {
        paddingBottom: 0,
      },
      width: 1100,
      current: this.step,
      steps: steps,
      show: this.showModal,
      cancel: changeModalType,
      title: this.lang.create,
      changeCurr: (current) => (this.step = current),
    };

    return this.renderDialogWithStepForm(props);
  }

  renderLeft() {
    // const style = getStyles("list");
    const columns = [
      {
        title: this.lang.actions,
        width: 80,
        customRender: (row) => {
          return this.renderPopconfirmWrapper({
            slot: (
              <a
                onClick={() => this.deleteList(row)}
                v-acl={ACLS.DELETE_WORKSTATION}
                style={{color: 'red'}}
              >
                {this.lang.delete}
              </a>
            ),
            rest: {
              slot: "actions",
            },
          });
        },
      },
      {
        title: this.lang.name,
        dataIndex: "name",
        width: 140,
      },
      {
        title: this.$t("page_calendar_code"),
        dataIndex: "code",
        width: 140,
      },
    ];

    return (
      <div style="overflow-y: auto;height:100%;background:#fff">
        <ml-table
          rowKey="id"
          size="small"
          style="background:#fff"
          columns={columns}
          dataSource={this.lists}
          pagination={false}
          selectRowKey={this.selectId}
          row-selection={{ selectedRowKeys: this.selectedRowKeys, onChange: this.onSelectChange }}
          customRow={(item) => ({
            on: {
              click: () => {
                this.chooseList(item.id);
              },
            },
          })}
        ></ml-table>
      </div>
    );
  }

  onSelectChange(selectedRowKeys, selectedRows) {
    console.log(selectedRowKeys);
    this.selectedRowKeys = selectedRowKeys;
  }

  renderRight() {
    return (
      <WorkstationSetting
        productInfo={this.productInfo}
        parameterSetting={this.parameterSetting}
        associatedIot={this.associatedIot}
        workstationId={this.selectId}
        workstation={this.select}
      />
    );
  }

  refreshProductInfo() {
    this.getDetailFunction(
      service.getWorkStation.bind(service),
      "productInfo"
    )(this.selectId);
  }

  getProductInfoFunction() {
    return this.getDetailFunction(
      service.getWorkStation.bind(service),
      "productInfo"
    );
  }

  getParameterSettingFunction() {
    return this.getDetailFunction(
      paramSettingService.getWorkingConditionParams.bind(paramSettingService),
      "parameterSetting"
    );
  }

  getAssociatedIotFunction() {
    return this.getDetailFunction(
      IotService.getIotsByWorkstationId.bind(IotService),
      "associatedIot"
    );
  }
}
